"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const inquiries = [{
  question: "How does International Experiences select its global talent?",
  answer: "We maintain an elite scouting network that spans the globe, identifying musicians, dancers, and circus performers who possess not just technical mastery, but a unique 'star' quality that commands the world's most prestigious stages."
}, {
  question: "What regions do your performers currently tour?",
  answer: "Our reach is truly worldwide. From the grand theaters of Europe and the high-energy arenas of North America to the luxury residencies in Asia and the Middle East, we bring world-class entertainment to every corner of the globe."
}, {
  question: "Can you provide custom choreography for specific events?",
  answer: "Absolutely. We specialize in bespoke artistic direction. Our creative team works closely with clients to tailor performances—whether it's a high-fashion gala or a stadium tour—ensuring the narrative aligns perfectly with your vision."
}, {
  question: "What is the process for securing a 'Star' for our stage?",
  answer: "The process begins with a consultation to understand your event's scale and aesthetic. We then curate a selection from our roster, handle all international logistics, and ensure a seamless integration of talent into your production."
}];
export default function CommonInquiries() {
  return <section data-section-id="222890" id="common-inquiries" className="bg-background text-foreground py-24 px-6 md:px-12 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,215,0,0.03)_0,transparent_100%)] pointer-events-none" />

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-widest uppercase mb-4">
            The Backstage Brief
          </h2>
          <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto tracking-wide">
            Essential details regarding our global roster, elite logistics, and the art of the stage.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {inquiries.map((inquiry, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border border-border bg-card/30 px-6 md:px-8 data-[state=open]:bg-secondary/50 transition-colors duration-500 rounded-md shadow-sm">
              <AccordionTrigger className="font-serif text-xl md:text-2xl py-6 md:py-8 hover:no-underline [&>svg:last-child]:hidden group">
                <span className="text-left pr-8 font-medium tracking-wider text-foreground">
                  {inquiry.question}
                </span>
                <div className="relative size-6 shrink-0 flex items-center justify-center text-primary group-hover:text-primary transition-colors duration-300">
                  <Plus className="absolute size-6 transition-all duration-500 group-data-[state=open]:opacity-0 group-data-[state=open]:rotate-90 stroke-[1]" />
                  <Minus className="absolute size-6 transition-all duration-500 opacity-0 -rotate-90 group-data-[state=open]:opacity-100 group-data-[state=open]:rotate-0 stroke-[1]" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="font-default text-muted-foreground leading-[1.8] text-base md:text-lg pb-8 pt-2 max-w-3xl">
                {inquiry.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}